import styled from "styled-components";
import { device } from "../styles/Reset";

export const Button = styled.button`
  display: block;
  height: 40px;
  margin: 10px auto 5px auto;
  padding: 5px;
  background: ${(props) => props.theme.themeGlobal.main};
  color: #fff;
  border-radius: 5px;
  min-width: 220px;

  &.secondary {
    border: none;
    color: #89989d;
    font-size: 1.1rem;
    background: transparent;
    padding: 0;
    height: auto;
    margin: 0 auto;
    font-weight: normal;
    text-align: right;
    text-decoration: underline;
    margin-top: 5px;
    padding-right: 15px;
  }
  @media ${device.laptop} {
    cursor: pointer;
    display: inline-block;
    min-width: 140px;
    width: 80%;
  }
`;

export const ButtonWrapper = styled.div`
  display: block;
  padding-top: 0;
  @media ${device.laptop} {
    width: 19%;
    padding-top: 20px;
    display: inline-block;
    margin-left: 0;
  }
`;

export const TextWrapper = styled.div`
  width: 100%;
  display: inline-block;
  padding-bottom: 5px;
  padding-right: 20px;
  font-family: Arial, sans-serif;
  line-height: 1.9rem;
  font-size: 1.3rem;
  > h2 {
    text-align: left;
    font-size: 1.3rem;
    padding: 0 0 6px 0;
    color: ${(props) => props.theme.themeGlobal.textColor};
  }
  > a,
  > a:link,
  > a:visited,
  > a:hover,
  > a:active {
    color: rgb(137, 152, 157);
  }
  @media ${device.laptop} {
    width: 80%;
    max-width: 500px;
    padding-right: 0;
    line-height: 2.1rem;
    font-size: 1.5rem;
    padding-bottom: 15px;
    > h2 {
      font-size: 1.5rem;
    }
  }
`;

export const Heading = styled.h2`
  font-size: 35px;
`;

export const Section = styled.h3`
  font-family: ${(props) => props.theme.themeGlobal.headingFont};
  text-align: left;
  margin-bottom: 0;
  border-bottom: 2px solid ${(props) => props.theme.themeGlobal.secondary};
  padding-bottom: 5px;
`;

export const Subheading = styled.h4`
  margin-top: 15px;
  color: ${(props) => props.theme.themeGlobal.headingColor};
`;

export const Wrapper = styled.div`
  text-align: left;
  > h2 {
    padding: 20px 0;
  }
  > h3 {
    margin-top: 15px;
    border-top: 1px solid #ccc;
  }
  > h4 {
    margin: 15px 0 8px 0;
  }
  > ul.noBullet {
    list-style-type: none;
    margin-top: 8px;
    margin-left: 0;
  }

  > p a,
  > ul li a {
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-all;
    word-break: break-word;
    hyphens: auto;
    color: ${(props) => props.theme.themeGlobal.main};
  }
  > div iframe ul li {
    margin: 8px 0;
  }
`;

export const Paragraph = styled.p`
  margin-top: 8px;
`;
